import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6e4780c5&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "../../static/oa-img/css/user.css?vue&type=style&index=0&id=6e4780c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4780c5",
  null
  
)

export default component.exports